import { PrivateDocumentForm } from '@/shared/lib/forms/documents/private';
import { PrivateDocumentDto } from '@/shared/lib/sj-orm';
import { dates } from '@/shared/utils/dates';

const EXPIRATION_IN_DAYS = 30;

export const getSectionsArray = (formConfig: typeof PrivateDocumentForm) => {
  const entries = Object.entries(formConfig);

  const withOrder = entries.map(([key, value], index, { length }) => ({
    key,
    value,
    order: value?.order !== undefined ? Number(value.order) : length + index,
  }));

  withOrder.sort((a, b) => Number(a.order) - Number(b.order));

  return withOrder.reduce(
    (result, { key, value }, index) => {
      if (index < 3) {
        result[0] = { ...result[0], ...{ [key]: value } };
      } else {
        result[1] = { ...result[1], ...{ [key]: value } };
      }

      return result;
    },
    [{}, {}],
  );
};

export const isPrivateDocumentExpiring = (item: PrivateDocumentDto) => {
  if (!item.stopDate) return false;

  return dates.diffDate(new Date(item.stopDate), new Date()) <= EXPIRATION_IN_DAYS;
};
